import { render, staticRenderFns } from "./CredenciamentoFornecedorEsclarecimentoImpugnacao.vue?vue&type=template&id=82ced0fa&scoped=true"
import script from "./CredenciamentoFornecedorEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ced0fa",
  null
  
)

export default component.exports